import { render, staticRenderFns } from "./sessionRanking.vue?vue&type=template&id=4de69ae1&scoped=true"
import script from "./sessionRanking.vue?vue&type=script&lang=js"
export * from "./sessionRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de69ae1",
  null
  
)

export default component.exports